import { Formik } from "formik";
import { useState } from "react";
import { getSelectOptionsFromEnum, showToast } from "../../../../utils/miscFunctions";
import SelectDropdown from "../../../../components/form-control/SelectDropdown";
import { PAYMENT_CHANNELS, PAYMENT_CHANNELS_WITHOUT_BANK_WITHOUT_VOUCHER } from "../../../../resources/enums";
import Button from "../../../../components/form-control/Button";
import Input from "../../../../components/form-control/Input";
import * as Yup from "yup";
import DatePickerInput from "../../../../components/form-control/DatePickerInput";
import { completeDisbursement } from "../../../../services/disbursements";
import Disbursement from "../../../../models/Disbursement";
import { getFormattedDate } from "../../../../utils/miscFunctions";

interface CompleteDisbursementProps {
    onProceed: () => void;
    onClose: () => void;
    disbursement: Disbursement;
}

const CompleteDisbursement = ({ onProceed, onClose, disbursement }: CompleteDisbursementProps) => {
    const [loading, setLoading] = useState<boolean>(false);
    const balance = disbursement?.amountToSettle - disbursement?.amountPaid;

    return (
        <div className="">
            <Formik
                initialValues={{
                    paymentAmount: balance,
                    paymentChannel: '',
                    paymentDate: null,
                    paymentReference: ''
                }}
                enableReinitialize={true}
                validateOnChange={false}
                validateOnBlur={false}
                validationSchema={Yup.object().shape({
                    paymentAmount: Yup.number().required('Payment amount is required.'),
                    paymentChannel: Yup.string().trim().required('Payment Channel is required.'),
                    paymentDate: Yup.string().trim().required('Date of transaction is required.').nullable(),
                    paymentReference: Yup.string().trim().required('Payment reference is required.')
                })}
                onSubmit={async (values) => {
                    const payload: any = {
                        paymentAmount: values.paymentAmount,
                        paymentChannel: values.paymentChannel,
                        paymentDate: getFormattedDate({ date: values.paymentDate, toServer: true }),
                        paymentReference: values.paymentReference
                    };

                    try {
                        setLoading(true);
                        const response: any = await completeDisbursement(disbursement.id, payload);
                        if (response) {
                            showToast.success(response?.message || 'Disbursement completed successfully');
                            onProceed();
                        }
                    } catch (error: any) {
                        showToast.error(error?.description || 'Failed to complete disbursement');
                    } finally {
                        setLoading(false);
                    }
                }}>
                {({
                    values,
                    errors,
                    isSubmitting,
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    setFieldValue,
                    touched
                }) => (
                    <form className="p-6" onSubmit={handleSubmit}>
                        <div className="w-full space-y-5 ">
                            <Input
                                type={'number'}
                                name="paymentAmount"
                                value={values.paymentAmount}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                label="Payment amount"
                                placeholder="Enter payment amount"
                                required
                                error={touched.paymentAmount ? errors.paymentAmount : undefined}
                                helperText={touched?.paymentAmount ? errors.paymentAmount : undefined}
                                className="rounded"
                            />

                            <Input
                                type={'text'}
                                name="paymentReference"
                                value={values.paymentReference}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                label="Payment reference"
                                placeholder="Enter payment reference"
                                required
                                error={touched.paymentReference ? errors.paymentReference : undefined}
                                helperText={touched?.paymentReference ? errors.paymentReference : undefined}
                                className="rounded"
                            />


                            <SelectDropdown
                                name="paymentChannel"
                                listSelectedValue={values.paymentChannel}
                                onChange={(value: string) => {
                                    setFieldValue('paymentChannel', value);
                                   
                                }}
                                label="Payment channel"
                                placeholder="Select payment channel"
                                list={getSelectOptionsFromEnum(PAYMENT_CHANNELS_WITHOUT_BANK_WITHOUT_VOUCHER)}
                                required
                                error={touched.paymentChannel ? errors.paymentChannel : undefined}
                                helperText={touched?.paymentChannel ? errors.paymentChannel : undefined}
                                selectInputClassName="rounded"
                            />

                            <div className="w-full">
                                <DatePickerInput
                                    id="paymentDate"
                                    selected={values.paymentDate}
                                    onChange={(date) => setFieldValue('paymentDate', date)}
                                    classes=''
                                    dateFormat="MM-dd-yyyy"
                                    label="Date of Transaction"
                                    showYearDropdown
                                    allowEarlierSelections={true}
                                    allowFutureSelections={false}
                                    error={touched.paymentDate ? errors.paymentDate : undefined}
                                    helperText={touched.paymentDate ? errors.paymentDate : undefined}
                                    required
                                />
                            </div>

                        </div>


                        <div className="flex-col-reverse gap-5 flex md:flex-row  mt-10 items-center justify-end">
                            <Button
                                label="Cancel"
                                onClick={onClose}
                                curved
                                className="  rounded border border-primary-border hover:bg-primary-main "
                            />

                            <Button
                                label="Continue"
                                className=" rounded border border-primary-borde bg-primary-main "
                                onClick={handleSubmit}
                                disabled={loading}
                                loading={loading}
                                curved
                                bgColor="primary"
                            />
                        </div>
                    </form >
                )}
            </Formik >
        </div >
    );
};

export default CompleteDisbursement;
